const { hexToRgb, objectToCssVarsString, shadeColor } = require('@/functions/css');

/**
 * Fetches the company's themes from the API and generates CSS for different screens based on the theme.
 *
 * @constructor
 *
 * @param $rootScope
 * @param {ApiClient} apiClient
 */
const ThemeManager = function (
    $rootScope,
    apiClient,
) {
    this.$rootScope = $rootScope;
    this.apiClient = apiClient;
};

ThemeManager.prototype = {
    /**
     * Load the CSS for the given theme using the given stylesheet name (frontend, kitchen-customer etc.).
     * See ThemeStyleFactory in app for more info on themes/stylesheets.
     *
     * @param {Number} themeID
     */
    enableTheme: function (themeID) {
        // Fetch the CSS vars from the API.
        this.apiClient.request(
            'GET',
            'themes/' + themeID + '/css'
        )
            .then((response) => {
                if (response && response.data) {
                    this.setThemeCssVars(response.data.cssVarsString || '');
                    this.setThemeCssFonts(response.data.cssFontsString || '');

                    const extraVars = this.generateAdditionalCssVars(response.data.cssVars);
                    this.setStyleBlock('custom-theme-css-vars', objectToCssVarsString(extraVars));
                }
            });
    },

    /**
     * For some things we need to calculate some extra vars that are not supplied by the API.
     *
     * @param {object} themeCssVars
     */
    generateAdditionalCssVars(themeCssVars) {
        const extraVars = {
            accentColourRgb: Object.values(hexToRgb(themeCssVars.accentColour)).join(','),
            tenPercentLighterAdditionalColour: shadeColor(themeCssVars.additionalColour, 10),
        };

        return extraVars;
    },

    /**
     * @param {string} id
     * @param {string} content
     */
    setStyleBlock(id, content) {
        const existingStyle = document.getElementById(id);
        if (existingStyle) {
            existingStyle.parentNode.removeChild(existingStyle);
        }

        if (content) {
            const newStyle = document.createElement('style');
            newStyle.id = id;
            newStyle.innerHTML = content;
            document.head.appendChild(newStyle);
        }
    },

    setThemeCssVars(varsString) {
        this.setStyleBlock('theme-css-vars', varsString);
    },

    setThemeCssFonts(fontsString) {
        this.setStyleBlock('theme-css-fonts', fontsString);
    },
};

module.exports = ThemeManager;
